import { actionCobraAuth, actionCobraTryBackgroundLogin } from './actions.js';
/**
 * @returns {Promise<boolean>} true if client has valid refresh token
 */
export const initCobraAuth = async (dispatch, onReplaceUrl) => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const session_state = params.get('session_state');
    if (session_state && code) {
        return await dispatch(actionCobraAuth({ code }, onReplaceUrl));
    }
    else {
        return await dispatch(actionCobraTryBackgroundLogin());
    }
};
//# sourceMappingURL=initAuth.js.map